import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "./firebase"; // adjust this import as needed

export const checkHasPlayedDaily = async (uid, dateKey) => {
  const ref = doc(db, "dailyPlays", uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) return false;

  const data = snap.data();
  return !!data[dateKey];
};

// ✅ This marks the user as having played that day
export const markDailyGamePlayed = async (uid, dateKey) => {
    const ref = doc(db, "dailyPlays", uid);
    await setDoc(ref, { [dateKey]: true }, { merge: true });
  };